import styled from 'styled-components';
import { DefaultModalComponents } from '../../ProjectModal/utils';
import AppCSS from '../../../utils/styled';
import { Form } from 'formik';

export const Components = {
  ...DefaultModalComponents,
  Form: styled(Form)`
    width: 100%;
  `,

  FieldsWrapper: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 3px calc(100% - 11px);
    grid-column-gap: 8px;
  `,
  FieldsContent: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldStartAdornment: styled.div<{ variant: 'minimal' | 'additional' }>`
    min-height: 24px;
    height: auto;
    width: 3px;
    ${AppCSS.radiuses.small};
    background-color: ${({ variant }) => {
      switch (variant) {
        case 'minimal':
          return AppCSS.colors.red;
        case 'additional':
          return AppCSS.colors.greys.darker;
      }
    }};
  `,

  FieldWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,

  SectionLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
    margin-top: 8px;
  `,

  PathsList: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,

  PathCard: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border: 1px solid ${AppCSS.colors.greys.light};
    ${AppCSS.radiuses.small};
    background-color: ${AppCSS.colors.utility.screenBackground};
  `,

  PathCardHeader: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,

  PathCardTitle: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,

  PathCardActions: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  `,

  IconButton: styled.button`
    cursor: pointer;
    border: none;
    background: transparent;
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
    padding: 4px 8px;
    ${AppCSS.radiuses.small};

    &:hover {
      background-color: ${AppCSS.colors.greys.light};
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  `,

  RemoveButton: styled.button`
    cursor: pointer;
    border: none;
    background: transparent;
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.red};
    padding: 4px 8px;
    ${AppCSS.radiuses.small};

    &:hover {
      background-color: ${AppCSS.colors.greys.light};
    }
  `,

  AddPathButton: styled.button`
    cursor: pointer;
    width: 100%;
    border: 1px dashed ${AppCSS.colors.greys.darker};
    background: transparent;
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
    padding: 10px;
    ${AppCSS.radiuses.small};

    &:hover {
      background-color: ${AppCSS.colors.greys.light};
    }
  `,

  PathFieldError: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.red};
  `,
};
